import { render } from "./EmpleadoArchivoTipoList.vue?vue&type=template&id=0db9bb4a&scoped=true"
import script from "./EmpleadoArchivoTipoList.vue?vue&type=script&lang=js"
export * from "./EmpleadoArchivoTipoList.vue?vue&type=script&lang=js"

import "./EmpleadoArchivoTipoList.vue?vue&type=style&index=0&id=0db9bb4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db9bb4a"]])

export default __exports__